// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2tc7u","upload":"Small_upload__B0ABr","imageWrap":"Small_imageWrap__L1BJC","removeBtn":"Small_removeBtn__2W2Bw"};